const allowedProtocols = new Set(["http:", "https:", "mailto:", "tel:"])
const externalHttpProtocols = new Set(["http:", "https:"])
const protocolPattern = /^[a-z][a-z\d+.-]*:/i

export const normalizeHref = (href) => {
    if (href === null || href === undefined) return undefined

    const hrefString = String(href).trim()

    if (!hrefString) return undefined

    if (hrefString.startsWith("//")) return undefined

    if (hrefString.startsWith("/") || hrefString.startsWith("#")) {
        return hrefString
    }

    if (protocolPattern.test(hrefString)) {
        try {
            return allowedProtocols.has(new URL(hrefString).protocol)
                ? hrefString
                : undefined
        } catch {
            return undefined
        }
    }

    return `https://${hrefString}`
}

export const normalizeExternalHttpUrl = (href) => {
    const normalizedHref = normalizeHref(href)

    if (!normalizedHref) return undefined

    try {
        const url = new URL(normalizedHref)

        return externalHttpProtocols.has(url.protocol) ? url.href : undefined
    } catch {
        return undefined
    }
}
